export default __webpack_public_path__ + "static/media/CNo.34-3.e64d1854.jpg";